import { uploadUrl, docUpLoad } from '../api';
const docMgr = {
  namespaced: true,
  state: {
    resp: {},
    total: null,
    uploadUrl,
    docUpLoadResp:null
  },
  mutations: {
    DOC_DATA(state, data) {
      state.docUpLoadResp = data;
    },
  },
  actions: {
    //导入数据
    async docUpLoad({ commit }, obj) {
      let resp = await docUpLoad(obj);
      commit('DOC_DATA', resp);
    },
  },
}

export default docMgr



// WEBPACK FOOTER //
// ./src/page/sm/docMgr/store/docMgr.store.js